import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class PDFView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pages: 0 };
    this.clickedBack = this.clickedBack.bind(this);
    this.getPageCount = this.getPageCount.bind(this);
    this.buildPages = this.buildPages.bind(this);
  }

  clickedBack() {
    this.props.restart();
  }

  getPageCount(doc) {
    this.setState({ pages: doc.numPages });
  }

  buildPages() {
    let pages = [];
    for (let i = 1; i < this.state.pages; i++) {
      pages.push(<Page pageNumber={i} />);
    }
    return pages;
  }

  render() {
    return (
      <div>
        <div className="pdfHolder">
          <Document file={this.props.pdf} onLoadSuccess={this.getPageCount}>
            {this.buildPages()}
          </Document>
        </div>
        <button
          id="management_back"
          className="back btn btn-secondary"
          value="&lt Back"
          onClick={this.clickedBack}
        >
          &lt; Back
        </button>
      </div>
    );
  }
}

export default PDFView;
